import { ExpertProfileType } from '@@types/api.types.ts';
import { ExpertProfileComponentProps } from '@components/pages/expert-profile/components/expert-profile-modal.component.tsx';
import { ErrorMessage } from '@components/shared/error-message.component';
import { SelectionCard } from '@components/shared/selection-card.component';
import { cn } from '@lib/utils';
import { CpuIcon, StarIcon } from 'lucide-react';
import { FunctionComponent } from 'react';

interface TypeStepProps extends ExpertProfileComponentProps {}

const expertTypes = [
  {
    value: ExpertProfileType.VETERAN,
    icon: (isSelected: boolean) => <StarIcon className={cn('h-3/5 w-3/5', isSelected && 'text-indigo-700')} />,
    primaryLabel: 'Veteran',
    secondaryLabel: 'Military experience',
  },
  {
    value: ExpertProfileType.TECHNOLOGY_SPECIALIST,
    icon: (isSelected: boolean) => <CpuIcon className={cn('h-3/5 w-3/5', isSelected && 'text-indigo-700')} />,
    primaryLabel: 'Technology specialist',
    secondaryLabel: 'No military experience',
  },
];

export const ExpertProfileTypeStep: FunctionComponent<TypeStepProps> = (props) => {
  const { formData, setFormData, errors } = props;

  const handleTypeSelect = (type: ExpertProfileType) => {
    setFormData((prevData) => ({
      ...prevData,
      type,
    }));
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row items-start justify-center gap-4">
        {expertTypes.map(({ value, icon, primaryLabel, secondaryLabel }) => (
          <SelectionCard
            key={value}
            value={value}
            icon={icon}
            primaryLabel={primaryLabel}
            secondaryLabel={secondaryLabel}
            isSelected={formData.type === value}
            onClick={() => handleTypeSelect(value)}
            onKeyUp={(e) => (e.key === 'Enter' || e.key === ' ') && handleTypeSelect(value)}
          />
        ))}
      </div>
      <ErrorMessage zodError={errors.type} />
    </div>
  );
};
